import React, { useState } from 'react';
import { ChromePicker, ColorResult } from 'react-color';

const ColorPicker = ({color, setColor}: {color: any, setColor: any}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
 
  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (newColor: ColorResult) => {
    setColor(newColor);
  };

  return (
    <div className="flex items-center">
      <div
        className="rounded-md bg-white p-1 cursor-pointer"
        onClick={handleClick}
      >
        <div
          className="rounded-md w-10 h-6"
          style={{ backgroundColor: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})` }}
        />
      </div>
      {displayColorPicker && (
        <div className="absolute z-10">
          <div
            className="fixed inset-0"
            onClick={handleClose}
          />
          <ChromePicker color={color.rgb} onChange={handleChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
